module KendoWidgets
{
	export class GroupBoxOptions
	{
		width?: string | number;
		height?: string | number;
		legendSettings?: GroupBoxLegendSettings;
		content?: string | HTMLElement | JQuery;
		buttons?: GroupBoxButton[];
		collapsable?: boolean;
		startingCollapsed?: boolean;
		css?: string;
		checkboxes?: boolean;

		checkboxClick?(e: GroupBoxCheckboxClickEvent): void;
		collapse?(e: GroupBoxCollapseEvent): void;
		expand?(e: GroupBoxExpandEvent): void;
	}

	export class GroupBox extends kendo.ui.Widget implements KendoWidget
	{
		private _checkbox: KendoWidgets.CheckBox;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.GroupBox; }

		constructor(element: Element, options?: KendoWidgets.GroupBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.GroupBoxOptions();

			if (options.width == null) options.width = "calc(100% - 22px)";
			if (options.collapsable == null) options.collapsable = false;
			if (options.startingCollapsed == null) options.startingCollapsed = false;
			if (options.checkboxes == null) options.checkboxes = false;

			(element as HTMLElement).classList.add("k-groupbox");
			super(element, options);
			let that = this;

			//#region Width & Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;

			if (options.height != null)
			{
				if (typeof (options.height) == "number")
					options.height = options.height + "px";
				(element as HTMLElement).style.cssText += "height: " + options.height;
			}
			//#endregion

			let htmlContent = $(element).html();
			$(element).empty();

			//#region Legend
			let spanLegend = "";
			let spanLegendColor = "#000";
			let spanLegendBackgroundColor = "#FFF";
			let spanLegendBorderColor = "";
			if (options.legendSettings != null && options.legendSettings.text !== null && options.legendSettings.text !== "")
			{
				if (options.legendSettings.color != null) spanLegendColor = options.legendSettings.color;
				if (options.legendSettings.backgroundColor != null) spanLegendBackgroundColor = options.legendSettings.backgroundColor;
				if (options.legendSettings.borderColor != null) spanLegendBorderColor = "border-color: " + options.legendSettings.borderColor;

				spanLegend = "<span style='color: " + spanLegendColor + "; background-color: " + spanLegendBackgroundColor + "; " + spanLegendBorderColor + "'>"
					+ options.legendSettings.text + "</span>";
			}

			let h1LegendClass = "";
			if (options.collapsable && options.checkboxes)
				h1LegendClass = " class='groupBoxCollapsableAndCheckboxes'";
			else if (options.collapsable || options.checkboxes)
				h1LegendClass = " class='groupBoxCollapsable'";

			let legend = $("<h1" + h1LegendClass + " id='" + element.id + "Legend'>" + spanLegend + "</h1>").appendTo(element);
			if (options.legendSettings != null && options.legendSettings.click != null)
			{
				$(legend).click((e) =>
				{
					let clickLegendEvent = new GroupBoxLegendClickEvent();
					clickLegendEvent.sender = this;
					clickLegendEvent.text = (options!.legendSettings!.text != null) ? options!.legendSettings!.text : "";
					options!.legendSettings!.click!(clickLegendEvent);
				});
				$(legend).css("cursor", "pointer");
			}
			//#endregion

			//#region Buttons
			if (options.buttons != null)
			{
				let buttonsContainer = $("<div style='float: right; display: flex;' id='" + element.id + "ButtonsContainer' class='groupBox_container'></div>").appendTo(element);
				for (let button of options.buttons)
				{
					let buttonElement = document.createElement("button");
					buttonElement.classList.add("k-groupbox-button");
					if (button.value != null)
						buttonElement.classList.add(button.value);
					$(buttonsContainer).append(buttonElement);

					$(buttonElement).kendoButton(
						{
							icon: button.icon,
							imageUrl: button.imageUrl,
							click: button.click,
							tooltip: button.tooltip,
							textColor: button.color,
							backgroundColor: button.backgroundColor,
							isPrimaryButton: button.primaryButton,
							css: (button.border == null || button.border == false) ? "border: none" : ""
						});
				}
			}
			//#endregion

			//#region Checkbox
			if (options.checkboxes)
			{
				let marginLeftCheckbox = "";
				if (options.collapsable)
					marginLeftCheckbox = "margin-left: 35px;";

				let checkboxContainer = $("<div style='float: left; display: flex; margin-top: -26px; background: #FFF; " + marginLeftCheckbox + "' id='" + element.id + "CheckboxContainer'></div>").appendTo(element);
				let checkboxElement = document.createElement("input");
				checkboxElement.id = element.id + "Checkbox";
				checkboxElement.classList.add("k-groupbox-checkbox");
				$(checkboxContainer).append(checkboxElement);

				this._checkbox = $(checkboxElement).kendoCheckBox(
					{
						check: (e) =>
						{
							if (options!.checkboxClick != null)
							{
								let checkboxClickEvent = new GroupBoxCheckboxClickEvent();
								checkboxClickEvent.sender = this;
								checkboxClickEvent.isChecking = e.sender.checked();
								options!.checkboxClick(checkboxClickEvent);
							}
						}
					}).data("kendoCheckBox");
			}
			//#endregion

			//#region Collapse
			if (options.collapsable)
			{
				let collapseBtnContainer = $("<div style='float: left; display: flex;' id='" + element.id + "CollapseBtnContainer' class='groupBox_container'></div>").appendTo(element);
				let buttonElement = document.createElement("button");
				buttonElement.id = element.id + "CollapseBtn";
				buttonElement.classList.add("k-groupbox-button", "k-groupbox-button-collapse");
				$(collapseBtnContainer).append(buttonElement);

				$(buttonElement).kendoButton(
					{
						icon: "arrow-60-up",
						css: "border: none; color: #000",
						click: (e) =>
						{
							if ((e.sender as KendoWidgets.Button).icon() == "arrow-60-up")
								that.collapse();
							else
								that.expand();
						}
					});
			}
			//#endregion

			//#region Content
			let contentContainer = $("<div id='" + element.id + "ContentContainer'></div>").appendTo(element);
			$(contentContainer).append(htmlContent);

			if (options.content != null)
				$(contentContainer).append((typeof (options.content) == "string") ? options.content : $(options.content));
			//#endregion

			// Collapse
			if (options.startingCollapsed)
				window.setTimeout(() => this.collapse(false));

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion
		}

		legend(text?: string)
		{
			if (text != null)
				$("#" + this.element.attr("id") + "Legend").find("span").html(text);

			return $("#" + this.element.attr("id") + "Legend").find("span").html();
		}

		content(content?: string | HTMLElement | JQuery)
		{
			if (content != null)
			{
				$("#" + this.element.attr("id") + "ContentContainer").empty();
				$("#" + this.element.attr("id") + "ContentContainer").append((typeof (content) == "string") ? content : $(content));
			}
			return $("#" + this.element.attr("id") + "ContentContainer").children()[0];
		}

		collapse(triggerChange = true)
		{
			let button = $("#" + this.element.attr("id") + "CollapseBtn").data("kendoButton") as KendoWidgets.Button;
			if (button != null)
				button.icon("arrow-60-down");

			$("#" + this.element.attr("id") + "ContentContainer").hide();
			$(this.element).height(0);

			if (triggerChange)
			{
				let options = this.getOptions();
				if (options.collapse != null)
				{
					let event = new GroupBoxCollapseEvent();
					event.sender = this;
					options.collapse(event);
				}
			}
		}

		expand(triggerChange = true)
		{
			let button = $("#" + this.element.attr("id") + "CollapseBtn").data("kendoButton") as KendoWidgets.Button;
			if (button != null)
				button.icon("arrow-60-up");

			$("#" + this.element.attr("id") + "ContentContainer").show();
			$(this.element).height($("#" + this.element.attr("id") + "ContentContainer").height() + 10);

			if (triggerChange)
			{
				let options = this.getOptions();
				if (options.expand != null)
				{
					let event = new GroupBoxCollapseEvent();
					event.sender = this;
					options.expand(event);
				}
			}
		}

		private getOptions()
		{
			return (this.options as KendoWidgets.GroupBoxOptions);
		}

		//#region Visible
		visible(state?: boolean)
		{
			if (state != null)
			{
				if (state) $(this.element).show();
				else $(this.element).hide();
			}
			return $(this.element).is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		//#region Check
		checked(state?: boolean)
		{
			if (state != null)
			{
				if (state) this._checkbox.checked(true);
				else this._checkbox.checked(false);
			}
			return this._checkbox.checked();
		}

		check()
		{
			this.checked(true);
		}

		uncheck()
		{
			this.checked(false);
		}
		//#endregion

		height(height?: string | number)
		{
			if (height != null)
				this.element.height(height);
			return this.element.height();
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion
	}

	GroupBox.fn = GroupBox.prototype;
	GroupBox.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	GroupBox.fn.options.name = "GroupBox";
	kendo.ui.plugin(GroupBox);

	class GroupBoxLegendSettings
	{
		text: string;
		color?: string;
		backgroundColor?: string;
		borderColor?: string;
		click?(e: GroupBoxLegendClickEvent): void;
	}

	export class GroupBoxButton
	{
		text?: string;
		icon?: string;
		imageUrl?: string;
		value?: string;
		backgroundColor?: string;
		color?: string;
		primaryButton?: boolean;
		border?: boolean;
		click?(): void;
		tooltip?: string;
	}

	class GroupBoxLegendClickEvent
	{
		sender: KendoWidgets.GroupBox;
		text: string;
	}

	class GroupBoxCheckboxClickEvent
	{
		sender: KendoWidgets.GroupBox;
		isChecking: boolean;
	}

	class GroupBoxCollapseEvent
	{
		sender: KendoWidgets.GroupBox;
	}
	class GroupBoxExpandEvent
	{
		sender: KendoWidgets.GroupBox;
	}
}

interface JQuery
{
	kendoGroupBox(options?: KendoWidgets.GroupBoxOptions): JQuery;
	data(key: "kendoGroupBox"): KendoWidgets.GroupBox;
}